import { render } from "./common-swiper.vue?vue&type=template&id=0cc3fd26&scoped=true"
import script from "./common-swiper.vue?vue&type=script&lang=js"
export * from "./common-swiper.vue?vue&type=script&lang=js"

import "./common-swiper.vue?vue&type=style&index=0&id=0cc3fd26&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc3fd26"]])

export default __exports__